import React, { useCallback } from 'react';
import { Button, Modal } from 'gatorcomponents';
import * as Styles from './TempDomainModal.styles';
import { useHistory } from 'react-router';
import useLocale from '@/hooks/useLocale';

const TempDomainModal = ({
  temporaryDomainModal,
  optionLabel = 'optionLabel',
  setTemporaryDomainModal,
}) => {
  const history = useHistory();
  const { routes: routesLocale, changeDomain: changeDomainLocale } = useLocale();

  const handleClose = useCallback(() => {
    setTemporaryDomainModal([]);
  }, [setTemporaryDomainModal]);

  const redirectToChangeDomainHandler = useCallback(({ domain, hostingId }) => {
    history.push(`/produtos${routesLocale.changeDomain}/${hostingId}/${domain}`);
  }, [
    history,
    routesLocale.changeDomain,
  ]);

  return (
    <Modal
      open
      onClose={handleClose}
      title={changeDomainLocale.tempDomainModalBeforeEmail.title}
    >
      <Styles.TempMailContentWrapper>
        <Styles.TempMailContent>
          {changeDomainLocale.tempDomainModalBeforeEmail.content(optionLabel)}
        </Styles.TempMailContent>

        <Styles.TempDomainList>
          {temporaryDomainModal.map(item => (
            <Styles.TempDomainListItem key={`${item.hosting_id}-${item.domain}`}>
              <Styles.DomainName>
                {item.domain}
              </Styles.DomainName>


              <Button
                testId={`changeDomain-${item.hosting_id}`}
                size="small"
                variant="text"
                label={changeDomainLocale.tempDomainModalBeforeEmail.changeDomainLabel}
                onClick={() => redirectToChangeDomainHandler({
                  domain: item.domain,
                  hostingId: item.hosting_id,
                })}
              />
            </Styles.TempDomainListItem>
          ))}
        </Styles.TempDomainList>

        <Styles.TempMailContent>
          {changeDomainLocale.tempDomainModalBeforeEmail.contentAfterList}
        </Styles.TempMailContent>


        <Styles.ActionsWrapper>
          <Button
            testId="backButton"
            variant="secondary"
            label={changeDomainLocale.tempDomainModalBeforeEmail.backLabel}
            onClick={handleClose}
          />
        </Styles.ActionsWrapper>
      </Styles.TempMailContentWrapper>
    </Modal>
  );
};

export default TempDomainModal;
